<script lang="ts">
  import TextNew from "../TextNew.svelte";

  export let title: string = "";
  export let height = 0;
</script>

<header bind:clientHeight={height}>
  {#if $$slots.title}
    <slot name="title" />
  {:else if title}
    <TextNew as="h1" size="xl" weight="medium">{title}</TextNew>
  {/if}
  <div class="content">
    <div>
      <slot name="left-aligned" />
    </div>
    <div>
      <slot name="right-aligned" />
    </div>
  </div>
</header>

<style>
  header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
  }
</style>
